module.exports = __webpack_public_path__ + "img/StruVital_LOGO_transparent_cropped.dcd487ca.png";